import { useContext } from "react";
import AuthContext from '../../redux/context/authProvider'

const useAuth = () => {
    return useContext(AuthContext);
}

export default useAuth;